export const List = () => {
  return (
    <>
      <h4 className="historyDate">Сегодня</h4>
      <div className="historyItem">
        <div>
          <div className="smallCard">
            <div className="iconCat Orange2Bg">
              <i className="cardIcon iconbank-qiwi"></i>
            </div>
            <div className="cardContent">
              <span className="cardContentValue">+ 23 000 ₽</span>
              <span className="cardContentLabel">Qiwi</span>
            </div>
          </div>
        </div>
      </div>
      <div className="historyItem">
        <div>
          <div className="smallCard">
            <div className="iconCat Blue1Bg">
              <i className="cardIcon iconcat-bag"></i>
            </div>
            <div className="cardContent">
              <span className="cardContentValue">- 6 000 ₽</span>
              <span className="cardContentLabel">Продукты</span>
            </div>
          </div>
        </div>
        <div className="historyComment">
          Купил много игрушек на подарки детям
        </div>
      </div>
      <div className="historyItem">
        <div>
          <div className="smallCard">
            <div className="iconCat Green2Bg">
              <i className="cardIcon iconcat-notebook"></i>
            </div>
            <div className="cardContent">
              <span className="cardContentValue">+ 15 000 ₽</span>
              <span className="cardContentLabel">Фриланс</span>
            </div>
          </div>
        </div>
      </div>
      <h4 className="historyDate">05.08.2022</h4>
      <div className="historyItem">
        <div>
          <div className="smallCard">
            <div className="iconCat Orange2Bg">
              <i className="cardIcon iconbank-qiwi"></i>
            </div>
            <div className="cardContent">
              <span className="cardContentValue">+ 23 000 ₽</span>
              <span className="cardContentLabel">Qiwi</span>
            </div>
          </div>
        </div>
      </div>
      <div className="historyItem">
        <div>
          <div className="smallCard">
            <div className="iconCat Blue1Bg">
              <i className="cardIcon iconcat-bag"></i>
            </div>
            <div className="cardContent">
              <span className="cardContentValue">- 6 000 ₽</span>
              <span className="cardContentLabel">Продукты</span>
            </div>
          </div>
        </div>
        <div className="historyComment">
          Купил много игрушек на подарки детям
        </div>
      </div>
      <div className="historyItem">
        <div>
          <div className="smallCard">
            <div className="iconCat Green2Bg">
              <i className="cardIcon iconcat-notebook"></i>
            </div>
            <div className="cardContent">
              <span className="cardContentValue">+ 15 000 ₽</span>
              <span className="cardContentLabel">Фриланс</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
